module.exports = __webpack_public_path__ + "img/personal-portfolio.f962305e.png";